import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/HU';
import { overview } from './overview/HU';
import { productInfoBox } from './productInfoBox/HU';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    dashboard,
    overview,
    productInfoBox,
};
